var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from './AppState';
import nodePlanDataDisplay from './components/nodePlanDataDisplay';
import { getAddressSuggestion } from './components/getAddressSuggestion';
import submitManualAddress from './components/submitManualAddress';
(function (Drupal, Window) {
    'use strict';
    Drupal.behaviors.plan_selection = {
        attach: function (context, settings) {
            const { baseUrl } = settings;
            const drupalJsObjects = {
                Drupal: Drupal,
                Window: Window,
                context: context,
                settings: settings
            };
            const currentUrl = new URL(Window.location.href);
            const manualAddressForm = context.querySelector('#manual-address-select-form');
            if (!currentUrl.searchParams.has('planId') && currentUrl.pathname === '/nbn-plans/service-qualification') {
                Window.location.href = `${baseUrl}/nbn-plans`;
            }
            else {
                AppState.set('planId', currentUrl.searchParams.get('planId'));
                AppState.set('planType', currentUrl.searchParams.get('planType'));
            }
            // Display the plan selected by user.
            Window.onload = () => __awaiter(this, void 0, void 0, function* () {
                yield nodePlanDataDisplay();
            });
            AppState.set('drupalJsObjects', drupalJsObjects);
            // User types address into address search field.
            context.querySelector('#edit-search-query').onkeyup = event => getAddressSuggestion(event);
            // User submits the Manual Address form.
            context.querySelector('#manual-address-submit').onclick = event => {
                submitManualAddress(event, manualAddressForm);
            };
            // User closes (and clears) the Manual Address form.
            context.querySelector('#manual-address-cancel').onclick = () => manualAddressForm.reset();
        }
    };
})(Drupal, window);
